import { BaseModel } from "sjs-base-model";
import InsuranceInfoModel from "./InsuranceInfoModel";

export default class ConvenantInfoModel extends BaseModel {
    public readonly convenant: number = 0;
    public readonly effectiveDate: string = "";
    public readonly insuranceInfo: InsuranceInfoModel = new InsuranceInfoModel({});

    constructor(data: Partial<ConvenantInfoModel>) {
        super();

        this.update(data);
    }
}
